import {IStore} from "modules/store";
import {createSelector} from "@reduxjs/toolkit";

const getState = ({contextualPrompt}: IStore) => contextualPrompt;

export const getContextualPromptData = createSelector(getState, (state) => state.prompt);

export const getContextualPromptIsOpen = createSelector(getState, (state) => state.isOpen);
